export const SET_SELECTED_YEAR = 'SET_SELECTED_YEAR';

export interface SetSelectedYearAction {
  type: typeof SET_SELECTED_YEAR;
  payload: {
    year: number;
  };
}

export const setSelectedYear = (year: number): SetSelectedYearAction => ({
  type: SET_SELECTED_YEAR,
  payload: { year },
});

export type YearActionTypes = SetSelectedYearAction;
